module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-flat-screen2@2x-09a9683ad21b8f0da325b9c36a922fca.png";